// extracted by mini-css-extract-plugin
module.exports = {"MySkills":"myskills_MySkills__26SAs","Blender":"myskills_Blender__ERtz4"};